<template>
  <div class="iframe">
    <iframe
      :src="resource.columns.url"
      :title="getTitle"
    />
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  mixins: [ editable ],
  computed: {
    getTitle () {
      return this.resource.columns.signature ? this.resource.columns.signature : null
    }
  }
}
</script>

<style lang="scss">
  @import '~beisheim/scss/colors';
  @import '~beisheim/scss/scale';
  @import '~beisheim/scss/zindex';
  @import '~beisheim/scss/font';
  @import '~beisheim/scss/breakpoints';
  @import '~beisheim/scss/grid';

  .iframe {
    position: relative;

    iframe {
      width: 100%;
      height: 100vh;
      border:0;
      margin:0;
      padding:0;
    }

    &__edit-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100vh;
    }
  }

</style>
